import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {parse} from "json2csv"
import {saveAs} from "file-saver"

class ExportDhlTracking extends Component {
    _parseTrackings = (items) => {

        return items.map(item => {
            const {orderNumber, products} = item
            const trackings = products.filter(product => {
                return product.hasOwnProperty('labelDetails')
            })
            let partnerTrackingNumber = ''
            if (trackings.length > 0) {
                const partnerTrackingNumbers = trackings.map(tracking => {
                    return tracking.labelDetails.partnerTrackingNumber
                })
                partnerTrackingNumber = partnerTrackingNumbers.join()
                return {orderNumber, tracking: partnerTrackingNumber}
            } else {
                if (item.labelDetails !== undefined && item.labelDetails.partnerTrackingNumber !== undefined) {
                    partnerTrackingNumber = item.labelDetails.partnerTrackingNumber
                    return {orderNumber, tracking: partnerTrackingNumber}
                }
            }

            return {orderNumber, tracking: ''}
        }).reverse()
    }

    _handleCopyTracking = () => {
        const {items} = this.props
        const tracking = this._parseTrackings(items)

        const fields = ['orderNumber', 'tracking']
        const opts = {fields}

        try {
            const csv = parse(tracking, opts)
            const file = new File([csv], 'tracking.csv', {type: 'application/csv; charset=UTF-8'})
            saveAs(file)
        } catch (err) {
            alert(err.message)
        }
    }

    render() {
        return (
            <Button className="btn-labeled btn-labeled-left ml-1" onClick={this._handleCopyTracking} color="primary">
                <b><i className="icon-truck"/></b>
                Tải về DHL Tracking
            </Button>
        )
    }
}

ExportDhlTracking.propTypes = {
    items: PropTypes.array.isRequired
}

export default ExportDhlTracking
